module.exports = __webpack_public_path__ + "img/item9.32362b6e.png";